<template>
  <div class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="style__titleHead__QII3Y common__clearfix__28XIR">
      <div class="title__title__RTC9P"><b>我的钱包</b><span>银行卡/USDT 地址管理</span></div>
    </div>
    <ul class="amountList__box__1_ZI4">
      <li style="width: 100%">
        <img src="/static/image/sdqianbao.dc40ee4f3863c42e32b6a486b5b706fc.svg" class="amountList__icon__33WXt" />
        <div class="amountList__infoWrap__3hanq">
          <span>钱包</span>
          <div class="amountList__info__3_qtq">
            <span class="amountList__amount__3uzil left_than">{{ $store.state.userInfo.balance }}</span
            ><span class="amountList__rmb__2yHNG">元</span><img @click="getBalances" src="/static/image/shuaxin.6eaac0e1956ef2120631f454674d245a.svg" class="amountList__refresh__3I1Qb" />
          </div>
        </div>
        <button @click="transall" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 80px; height: 28px; position: absolute; right: 18px; top: 15px; border-radius: 20px; font-size: 14px">一键回收</button>
      </li>
    </ul>
    <el-tabs v-model="activeName" style="margin-top: 20px">
      <el-tab-pane label="银行卡" name="bank">
        <div style="width: 100%; margin-bottom: 20px; display: flex; flex-wrap: wrap">
          <div class="usdt__card__1QL7m usdt__mid__2A8wC" style="width: 30%; margin-right: 10px; margin-top: 10px" v-for="(item, index) in usercardLis" :key="index">
            <p class="usdt__sub_tip__24nbZ">卡号：<span class="delss" @click="delCard(item.id)">解绑</span></p>
            <p class="usdt__sub_tip__24nbZ">{{ item.bank_no }}</p>
            <p class="usdt__sub_tip__24nbZ">银行户名：{{ item.bank_owner }}</p>
            <p class="usdt__sub_tip__24nbZ">开 户 行：{{ item.bank }}</p>
            <p class="usdt__sub_tip__24nbZ">银行地址：{{ item.bank_address }}</p>
          </div>
        </div>
        <button v-if="usercardLis.length < 5" @click="changBindShow(1)" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 440px; height: 50px; margin: 30px auto; display: block">添加银行卡</button>
      </el-tab-pane>
      <el-tab-pane label="USDT" name="usdt">
        <div style="width: 100%; margin-bottom: 20px; display: flex; flex-wrap: wrap">
          <div class="usdt__card__1QL7m usdt__mid__2A8wC" style="width: 30%; margin-right: 10px; margin-top: 10px" v-for="(item, index) in usdssLis" :key="index">
            <p class="usdt__sub_tip__24nbZ">钱包地址：<span class="delss" @click="delCard(item.id)">解绑</span></p>
            <p class="usdt__sub_tip__24nbZ">{{ item.bank_no }}</p>
            <p class="usdt__sub_tip__24nbZ">钱包类型：{{ item.bank }}</p>
            <p class="usdt__sub_tip__24nbZ">钱包协议：{{ item.bank_owner }}</p>
          </div>
        </div>
        <button v-if="usdssLis.length < 5" @click="changBindShow(2)" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 440px; height: 50px; margin: 30px auto; display: block">添加USDT地址</button>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加银行 -->
    <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" @click="changBindShow(0)" v-if="bindShow == 1">
      <div role="dialog" aria-modal="true" aria-label="绑定银行卡" class="el-dialog" style="margin-top: 15vh" @click="retrun">
        <div class="el-dialog__header">
          <span class="el-dialog__title">绑定银行卡</span><button type="button" @click="changBindShow(0)" aria-label="Close" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        </div>
        <div class="el-dialog__body">
          <div class="el-form el-form--inline">
            <div class="el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank" class="el-form-item__label" style="width: 150px">请选择支持银行</label>
                <el-select v-model="cardInfo.bank" placeholder="请选择支持银行" style="width: 380px">
                  <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写开户行</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_address" autocomplete="off" placeholder="请输入开户行" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写卡号</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_no" autocomplete="off" placeholder="填写卡号" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写持卡人姓名</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_owner" autocomplete="off" placeholder="填写持卡人姓名" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">支付密码</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="password" v-model="cardInfo.pay_pass" autocomplete="new-password" placeholder="支付密码" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px; padding-left: 150px">
              <button type="button" class="el-button el-button--primary" @click="bindCard"><span>绑定</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加USDT -->
    <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" @click="changBindShow(0)" v-if="bindShow == 2">
      <div role="dialog" aria-modal="true" aria-label="绑定USDT地址" class="el-dialog" style="margin-top: 15vh" @click="retrun">
        <div class="el-dialog__header">
          <span class="el-dialog__title">绑定USDT地址</span><button type="button" aria-label="Close" @click="changBindShow(0)" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        </div>
        <div class="el-dialog__body">
          <div class="el-form el-form--inline">
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">USDT地址</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="text" v-model="usdtInfo.bank_no" autocomplete="off" placeholder="绑定USDT地址" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">USDT协议</label>
                <div class="el-form-item__content">
                  <el-radio v-model="usdtInfo.bank_owner" label="ERC20">ERC20</el-radio>
                  <el-radio v-model="usdtInfo.bank_owner" label="TRC20">TRC20</el-radio>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">支付密码</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="password" v-model="usdtInfo.pay_pass" autocomplete="new-password" placeholder="支付密码" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px; padding-left: 150px">
              <button type="button" class="el-button el-button--primary" @click="bindUsdss"><span>绑定</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return {
      qutype: 0,
      amount: null,
      bankId: null,
      chanmeyXi: null,
      usercardLis: [],
      usdssLis: [],
      banklist: [],
      cardInfo: {},
      usdtInfo: {},
      password: null,
      bindShow: 0,
      activeName: 'bank',
    };
  },
  created() {
    let that = this;
    that.getUsercard();
    that.getUsdssList();
    that.getBanklist();
  },
  methods: {
    delCard(id) {
      let that = this;
      this.$confirm(`确定要解绑吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          that.$parent.showLoading();

          that.$apiFun.post('/api/delcard', { id }).then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }
            that.$parent.hideLoading();

            if (res.code == 200) {
              that.$parent.showTost(1, '解绑成功');
              that.getUsercard();
              that.getUsdssList();
            }
          });
        })
        .catch(() => {});
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getBalances() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },

    retrun(event) {
      event.stopPropagation();
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
    },
    changApiType(e) {
      let that = this;
      if (that.qutype == 1) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == e) {
            chanmeyXi = e.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }

      that.password = null;
      that.amount = null;
    },
    changBindShow(type) {
      let that = this;
      that.bindShow = type;
      that.cardInfo = {};
      that.usdtInfo = {};
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            that.changBindShow(0);
            that.getUsercard();
            that.getUsdssList();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输人银行卡号');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输人正确的卡号长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
          }
          that.changBindShow(0);
          that.getUsercard();
          that.getUsdssList();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },

    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },

    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Deposit_793450d6.94935135.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
.usdt__card__1QL7m {
  padding: 13px !important;
}
.delss {
  color: red;
  float: right;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/bankCard.vue